export default `
	headline
	team {
		... on TeamTeamMember {
			heading
			occupationTitle
			position
			photo {
				filename
				height
				id
				size
				url(transform:teamPortrait)
				width
			}
		}
	}
`;
